var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { TopMentionPlaceholderComponent } from '../../main/influencer/top-mention-placeholder/top-mention-placeholder.component';
import { PdfExportService } from '../../services/export-pdf/pdf-export.service';
import { UserService } from '../../services/user.service';
var AchooBarChartPlaceholderComponent = /** @class */ (function (_super) {
    __extends(AchooBarChartPlaceholderComponent, _super);
    function AchooBarChartPlaceholderComponent(pdfService, userService) {
        var _this = _super.call(this, pdfService, userService) || this;
        _this.pdfService = pdfService;
        _this.userService = userService;
        _this.isLeftSide = true;
        _this.isLarge = false;
        _this.showIndex = true;
        _this.startIndex = 0;
        _this.keywords = [];
        return _this;
    }
    AchooBarChartPlaceholderComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        if (this.keywords && this.keywords.length > 0) {
            this.data.forEach(function (data, i) {
                data['keyword'] = _this.keywords[i % _this.keywords.length];
            });
        }
    };
    return AchooBarChartPlaceholderComponent;
}(TopMentionPlaceholderComponent));
export { AchooBarChartPlaceholderComponent };



// WEBPACK FOOTER //
// ./src/app/core/achoo-bar-chart-placeholder/achoo-bar-chart-placeholder.component.ts.pre-build-optimizer.js